module.exports = __webpack_public_path__ + "img/help.1c7df21b.svg";